<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header
    v-if="!headerBarFixed"
    :class="[fixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
    :style="{ padding: '0' }">

    <div v-if="mode === 'sidemenu'" class="header" :class="theme">
      <span style="margin-left: 10px;margin-right: 20px" >
          <!--<a-button @click="routerHome" style="background: none;color: white">进入后台</a-button>-->
        <a @click="routerHome" >
            <img src="~@/assets/logo400x400.png" class="logo" alt="logo" style="">
            <span style="color: white;font-size: 18px;font-weight: bold">{{company}}</span>
          </a>
      </span>
      <span v-if="device === 'desktop'" style="margin-left: 10px">
        <!-- 欢迎进入{{platformName}} -->
        <a @click="downloadApp(record)" style="margin-left: 10px;color: white">下载APP</a>
      </span>
      <span v-else>{{platformName}}</span>
      <user-menu :isAdmin="isAdmin" :theme="theme"/>
      <!--<div  style="color: white;font-weight: bold;float: right;cursor: pointer" @click="goBackCenter">返回工作中心</div>-->
    </div>
    <!-- 顶部导航栏模式 -->
    <div v-else :class="['top-nav-header-index', theme]">
      <div class="header-index-wide">
        <div class="header-index-left" :style="topMenuStyle.headerIndexLeft">
          <logo class="top-nav-header" :show-title="device !== 'mobile'" :style="topMenuStyle.topNavHeader"/>
          <div v-if="device !== 'mobile'" :style="topMenuStyle.topSmenuStyle">
            <s-menu
              mode="horizontal"
              :menu="menus"
              :theme="theme"></s-menu>
          </div>
          <a-icon
            v-else
            class="trigger"
            :type="collapsed ? 'menu-fold' : 'menu-unfold'"
            @click="toggle"></a-icon>
        </div>
        <user-menu class="header-index-right" :theme="theme" :style="topMenuStyle.headerIndexRight"/>
      </div>
    </div>
    <a-modal
      title="app下载"
      :width="400"
      :visible="downloadApiVisible"
      switchFullscreen
      @ok="downloadApiVisible=false"
      @cancel="downloadApiVisible = false"
      cancelText="关闭">
      扫码后请在浏览器中打开，或者直接用浏览器扫码（IOS系统不支持下载）。
      <br/>
      <div style="width: 100%;text-align: center">
        <img src="app-download.png" style="width:300px;height:300px"/>
      </div>
    </a-modal>
  </a-layout-header>
</template>

<script>
  import UserMenu from '../../tools/UserMenu'
  import SMenu from '../../menu/'
  import Logo from '../../tools/Logo'
  import { mapGetters } from 'vuex'
  import { getAction } from '@/api/manage'

  import { mixin } from '@/utils/mixin.js'

  export default {
    name: 'GlobalHeader',
    components: {
      UserMenu,
      SMenu,
      Logo,
    },
    mixins: [mixin],
    props: {
      isAdmin:{
        type:Boolean,
        default:true,
      },
      mode: {
        type: String,
        // sidemenu, topmenu
        default: 'sidemenu'
      },
      menus: {
        type: Array,
        required: true
      },
      theme: {
        type: String,
        required: false,
        default: 'light'
      },
      collapsed: {
        type: Boolean,
        required: false,
        default: false
      },
      device: {
        type: String,
        required: false,
        default: 'desktop'
      }
    },
    data() {
      return {
        company:window._CONFIG.company,
        adminRole:window._CONFIG.adminRole,
        platformName:window._CONFIG['platformName'],
        headerBarFixed: false,
        //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
        topMenuStyle: {
          headerIndexLeft: {},
          topNavHeader: {},
          headerIndexRight: {},
          topSmenuStyle: {}
        },
        chatStatus: '',
        userRoles:[],
        downloadApiVisible:false,
      }
    },
    watch: {
      /** 监听设备变化 */
      device() {
        if (this.mode === 'topmenu') {
          this.buildTopMenuStyle()
        }
      },
      /** 监听导航栏模式变化 */
      mode(newVal) {
        if (newVal === 'topmenu') {
          this.buildTopMenuStyle()
        }
      }
    },
    //update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    mounted() {
      getAction('/sys/api/getUserRoleSet',{username:this.userInfo().username}).then(res=>{
        this.userRoles = res
      })
      window.addEventListener('scroll', this.handleScroll)
      //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
      if (this.mode === 'topmenu') {
        this.buildTopMenuStyle()
      }
      //update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    },
    methods: {
      ...mapGetters(["userInfo"]),
      goBackCenter(){
        this.$router.push({path:'/'})
      },
      downloadApp(){
        this.downloadApiVisible = true
      },
      routerHome(){
        // console.log('this.userRoles',this.userRoles)
        if(this.includes(this.adminRole,this.userRoles).length>0){
          this.$router.push({path:'/dashboard/analysis'})
        }
      },
      includes(arr1,arr2){
        return arr1.filter(item=>{
          return arr2.includes(item)
        })
      },
      handleScroll() {
        if (this.autoHideHeader) {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (scrollTop > 100) {
            this.headerBarFixed = true
          } else {
            this.headerBarFixed = false
          }
        } else {
          this.headerBarFixed = false
        }
      },
      toggle() {
        this.$emit('toggle')
      },
      //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
      buildTopMenuStyle() {
        if (this.mode === 'topmenu') {
          if (this.device === 'mobile') {
            // 手机端需要清空样式，否则显示会错乱
            this.topMenuStyle.topNavHeader = {}
            this.topMenuStyle.topSmenuStyle = {}
            this.topMenuStyle.headerIndexRight = {}
            this.topMenuStyle.headerIndexLeft = {}
          } else {
            let rightWidth = '360px'
            this.topMenuStyle.topNavHeader = { 'min-width': '165px' }
            this.topMenuStyle.topSmenuStyle = { 'width': 'calc(100% - 165px)' }
            this.topMenuStyle.headerIndexRight = { 'min-width': rightWidth }
            this.topMenuStyle.headerIndexLeft = { 'width': `calc(100% - ${rightWidth})` }
          }
        }
      }
      //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    }
  }
</script>

<style lang="less" scoped>
  /* update_begin author:scott date:20190220 for: 缩小首页布局顶部的高度*/

  @height: 59px;

  .layout {

    .top-nav-header-index {

      .header-index-wide {
        margin-left: 10px;

        .ant-menu.ant-menu-horizontal {
          height: @height;
          line-height: @height;
        }
      }
      .trigger {
        line-height: 64px;
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }

    .header {
      z-index: 2;
      color: white;
      height: @height;
      background-color: @primary-color;
      transition: background 300ms;

      /* dark 样式 */
      &.dark {
        color: #000000;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        background-color: white !important;
      }
    }

    .header, .top-nav-header-index {
      &.dark .trigger:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .ant-layout-header {
    height: @height;
    line-height: @height;
  }
  .logo {
    height: 32px;
    width: 35px;
    margin-top: 15px;
    vertical-align: top;
    margin-right: 16px;
    border-style: none;
  }
  /* update_end author:scott date:20190220 for: 缩小首页布局顶部的高度*/

</style>
